// extracted by mini-css-extract-plugin
module.exports = {"cardGrid":"signUpPage_cardGrid__1aM09","card":"signUpPage_card__X8fgB","cardWrapperImg":"signUpPage_cardWrapperImg__Bn8jI","cardTitle":"signUpPage_cardTitle__2IOfO"};